const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the users password edit component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Passcode} Passcode the resource defined to manage Passcode
 */
app.directive('userPasscodeChange', ['Application', 'Authorization', 'Passcode', '$translate', function (Application, Authorization, Passcode, $translate) {
    return {
      restrict: 'E',
      template: require('../../templates/directives/user-passcode-change.html'),
      controller: function () {
        var self = this;
        self.sso = false;
        self.user = Authorization.getAuthToken().user;
        self.company = Authorization.getAuthToken().company;
        if (self.company.sso_exemption && self.company.sso_exemption !== 'all') {
          if (self.company.sso_exemption === 'none' || self.company.sso_exemption === 'admin' && self.user.role !== 'admin') {
            self.sso = true;
          }
        }
        self.disableSubmit = true;

        self.updatePassword = function() {
          self.buttonLoading = true;
          Passcode.update({subresource: self.user._id}, {
            password: self.passOne
          }, function(data) {
            self.passOne = '';
            self.passTwo = '';
            self.disableSubmit = true;
            self.buttonLoading = false;
            Application.messaging.addMessage({type: 'success', text: self.translations['modules.notifications.password.updated'], duration: 5});
          }, function(error) {
            Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.canNotUpdatePassword'], duration: 5});
            self.disableSubmit = true;
            self.buttonLoading = false;
          });
        };

        self.checkChanges = function() {
          if (!!self.passOne && self.passOne === self.passTwo) {
            self.disableSubmit = false;
            return;
          }

          self.disableSubmit = true;
        };

        self.initialize = function () {
          self.passOne = '';
          self.passTwo = '';
        };
        $translate(['modules.notifications.password.updated', 'modules.notifications.canNotUpdatePassword']).then(function(data){
          self.translations = data;
          self.initialize();
        });

      },
      controllerAs: 'passcode'
    };
  }]);


